<template>
    <div class="my-3">
        <div class="row">
            <div class="col mb-3 text-right">
                <button class="btn btn-primary" @click="addTariff()">Agregar tarifa</button>
            </div>
        </div>
        <table id="result_list" class="table w-100 table-hover">
        <thead>
        <tr class="text-center">
            <th>Fecha</th>
<!--            <th>Vendido</th>-->
            <th v-for="item in type_tariffs" :key="'tt_'+ item.id">{{item.name}}</th>
            <th>Acciones</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="tariff_list && type_tariffs" v-for="t_date in Object.keys(tariff_list)" :key="'tl_'+ t_date" class="text-center">
            <td><span style="font-size: 1.1rem">{{t_date}}</span> <br>
                <span class="text-muted">Vendido / Stock</span>
            </td>
<!--            <td></td>-->
            <td v-for="item in type_tariffs" :key="t_date+'_tt_'+ item.id">
                <span v-if="getTariff(t_date,item.id)">
                <span style="font-size: 1rem">{{getTariff(t_date,item.id).price|currency}}</span>
                <span class="text-muted"><br/>{{getTariff(t_date,item.id).sold}} /
                    <span v-if="!item.default">{{getTariff(t_date,item.id).stock}}</span>
                    <span v-else> ~ </span>
                </span>
                </span>
            </td>
            <td>
                <button class="btn btn-primary" @click="editTariff(t_date)">Editar</button>
                <button class="btn btn-danger" @click="deleteTariff(t_date)">Eliminar</button>
            </td>
        </tr>
        </tbody>
    </table>

        <!-- Modal -->
<div class="modal fade" id="modalTariff" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Agregar / Editar Tarifas</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
        <form action="" id="form-tariffs">
            <div class="modal-body" v-if="tariff_dy">
                <div class="row">
                    <div class="form-group col-lg-4">
                        <label>Fecha Inicio</label>
                        <input type="date" class="form-control" v-model="tariff_dy.dt_init" :disabled="!new_tariff">
                    </div>
                    <div class="form-group col-lg-4">
                        <label>Fecha Fin</label>
                        <input type="date" class="form-control" v-model="tariff_dy.dt_end" :disabled="!new_tariff">
                    </div>
                </div>
                <div class="row">
                <div class="form-group col-lg-4" v-for="item in type_tariffs" :key="'md_tt_'+ item.id">
                    <label>{{item.name}} (Precio <span v-if="!item.default">/ Stock</span>)</label>
                    <input type="number" min="0" class="form-control mb-1" :name="'price_'+item.id" v-model="tariff_dy.data[item.id].price" placeholder="Precio">
                    <input v-if="!item.default" type="number" min="0" class="form-control" :name="'stock_'+item.id" v-model="tariff_dy.data[item.id].stock" placeholder="Stock">
                </div>

                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                <button type="button" class="btn btn-primary" @click="saveTariff()">Guardar</button>
            </div>
        </form>
    </div>
  </div>
</div>
    </div>
</template>

<script>

import API from '../api';

export default {
    props: {
        product_id: {
            required: true
        },
    },

    data() {
        return {
            modal_title: 'Agregar tarifas',
            show: false,
            loading: false,
            tariff_list: {},
            type_tariffs: [],
            new_tariff: true,
            tariff_dy: null,
            headers: {}
        }
    },
    methods: {
        getTariff(date, type){
            if (this.tariff_list.hasOwnProperty(date) && this.tariff_list[date].hasOwnProperty(type)) {
                return this.tariff_list[date][type]
            }
            return null
        },
        getTariffTypes(){
            this.loading = true;
            API.catalog.get_tariff_types().then((res)=>{
                this.type_tariffs = res;
                this.loading = false;
            })
        },
        postDynamicTariff(data){
            this.loading = true;
            API.catalog.post_dyamic_tariff(this.product_id, data, this.headers).then((res)=>{
                this.loading = false
                this.getDynamicTariffs()
                $('#modalTariff').modal('hide')
            }).catch(reason => {
                const Toast = Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.onmouseenter = Swal.stopTimer;
                        toast.onmouseleave = Swal.resumeTimer;
                    }
                });
                if (reason.response.status == 403){
                    Toast.fire({
                        icon: "error",
                        title: "Por favor recargue la página e intente de nuevo"
                    });
                    return
                }
                const resp = reason.response.data;
                let error_text = '';
                for (const key in resp) {
                    if (key == 'data') {
                        for (const subKey in resp[key]) {
                            error_text += `${subKey}: ${resp[key][subKey].join(', ')} \n`;
                        }
                    } else {
                        if (key == 'non_field_errors')
                            error_text += `${resp[key].join(', ')} \n`;
                        else
                            error_text += `${key}: ${resp[key].join(', ')} \n`;
                    }
                // console.log(error_text)
                }
                Toast.fire({
                    icon: "error",
                    title: error_text
                });
            })
        },
        deleteDynamicTariff(date){
            this.loading = true;
            // console.log(JSON.stringify(this.headers))
            API.catalog.delete_dynamic_tariffs(this.product_id, date, this.headers).then((res)=>{
                this.loading = false
                this.getDynamicTariffs()
            })
        },
        getDynamicTariffs(){
            this.loading = true;
            API.catalog.get_dynamic_tariffs(this.product_id).then((res)=>{
                this.tariff_list = res;
                this.loading = false;
            })
        },
        addTariff(){
            this.new_tariff = true
            this.tariff_dy = {
                dt_init: null,
                dt_end: null,
                data: {}
            }
            this.type_tariffs.forEach(item => {
                this.tariff_dy.data[item.id] = {price: 0, stock: 0}
            })

            $('#modalTariff').modal('show')
        },
        editTariff(date){
            this.new_tariff = false
            this.tariff_dy = {
                dt_init: date,
                dt_end: date,
                data: {},
            }
            this.type_tariffs.forEach(item => {
                let tf = this.getTariff(date, item.id)
                if (tf){
                    this.tariff_dy.data[item.id] = {price: tf.price, stock: tf.stock}
                } else {
                    this.tariff_dy.data[item.id] = {price: 0, stock: 0}
                }
            })

            $('#modalTariff').modal('show')
        },
        deleteTariff(date){
            Swal.fire({
                  title: "Estas seguro?",
                  text: "Se borraran las tarifas para del día " + date,
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Si, eliminar!',
                  cancelButtonText: 'Cancelar'
                }).then((result) => {
                  if (result.value) {
                      this.deleteDynamicTariff(date)
                  }
                })
        },
        saveTariff(){
            const payload = JSON.parse(JSON.stringify(this.tariff_dy))
            this.postDynamicTariff(payload)
        }
    },
    created: function (){
        this.getTariffTypes()
        this.getDynamicTariffs()
        this.headers = {'X-CSRFToken': $('[name=csrfmiddlewaretoken]').val()}
    }
}
</script>



// WEBPACK FOOTER //
// src/components/DynamicTariffs.vue